import api from "../../../services/api";
import { fixStrToNull, getRequestReplacingEmptyStringsToNull } from "../../../utils/utils";
import { setContracts, setStudents } from "../../slices/b2b/b2bContracts.slice";
import { endLoading, initLoading, setError } from "../../slices/generics.slice";
import { logout } from "../user.middleware";

const emptyFilter = {
  pageNumber: 1,
  pageSize: 100,
  code: "",
  companyId: "",
  economicGroupId: "",
  startDate: "",
  endDate: "",
  active: "",
};

export const fetchContracts = (filter = "") => {
  return async (dispatch) => {
    dispatch(initLoading());

    const req = getRequestReplacingEmptyStringsToNull(emptyFilter, filter);

    try {
      const response = await api.post("/contracts/search", req);

      const resp = response?.data?.result?.items;
      dispatch(setContracts(resp));
      return resp;
    } catch (error) {
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
      console.log("fetchContracts", error);
      dispatch(setError(error.message));
      dispatch(endLoading());
    } finally {
      dispatch(endLoading());
    }
  };
};

export const fetchStudents = (filter = "") => {
  return async (dispatch) => {
    dispatch(initLoading());

    const req = fixStrToNull(filter);
    req.status = req.status === null ? "active" : req.status;

    try {
      const response = await api.post("/contractstudents/search", req);

      const resp = response?.data?.result?.items;
      dispatch(setStudents(resp));
    } catch (error) {
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
      console.log("fetchStudents", error);
      dispatch(setError(error.message));
      dispatch(endLoading());
    } finally {
      dispatch(endLoading());
    }
  };
};

export const fetchStudentsReport = (filter = "") => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      const response = await api.get("/contractstudents/report", filter);

      const resp = response?.data?.result?.items;
      dispatch(setStudents(resp));
    } catch (error) {
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
      console.log("fetchStudents", error);
      dispatch(setError(error.message));
      dispatch(endLoading());
    } finally {
      dispatch(endLoading());
    }
  };
};

export const resetCycle = (job) => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      const response = await api.get(`/forcejob?job=${job}`);
      dispatch(endLoading());
      return response;
    } catch (error) {
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
      console.log("resetCycle", error);
      dispatch(endLoading());
    }
  };
};

export const fetchContractsById = (id) => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      const response = await api.get(`contracts/get/${id}`);

      const i = response.data.result.items[0];
      return i.contractPlans.map((contractPlan) => {
        return {
          contractPlanId: contractPlan.id,
          ...contractPlan.plan,
        };
      });
    } catch (error) {
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
      console.log("fetchContractsById", error);
      dispatch(setError(error.message));
      dispatch(endLoading());
    } finally {
      dispatch(endLoading());
    }
  };
};

export const saveStudent = (req) => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      if (req && req.id > 0) {
        return await api.put("contractstudents", req);
      }

      return await api.post("contractstudents", req);
    } catch (error) {
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
      console.log("saveStudent", error);
      dispatch(endLoading());
      throw error;
    } finally {
      dispatch(endLoading());
    }
  };
};

export const saveContract = (contract) => {
  return async (dispatch) => {
    dispatch(initLoading());

    const req = {
      id: contract.id,
      code: contract.code,
      description: contract.description,
      companyId: parseInt(contract.companyId),
      startDate: contract.startDate,
      endDate: contract.endDate,
      active: contract.active === "true" || contract.active,
      contractPlans: contract?.contractPlans?.map((item) => {
        const plan = {
          planId: parseInt(item.planId),
          quantity: parseInt(item.quantity),
        };
        if (item.id) {
          plan.id = parseInt(item.id);
        }
        return plan;
      }),
    };

    if (contract?.contractContacts?.length > 0) {
      let ids = [];
      contract.contractContacts.forEach((item) => {
        const id = parseInt(item.contactId ? item.contactId : item.id, 10);
        if (id > 0) {
          ids.push(id);
        }
      });
      req.contactIds = ids;
    }

    try {
      if (req && req.id > 0) {
        return await api.put("contracts", req);
      }
      delete req.id;
      return await api.post("contracts", req);
    } catch (error) {
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
      console.log("saveStudent", error);
      dispatch(endLoading());
      throw error;
    } finally {
      dispatch(endLoading());
    }
  };
};
export const bulkInsert = (contractId, data) => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      return await api.post(`contractstudents/uploadExcel/${contractId}`, data, {
        ...Headers,
        "Content-Type": "multipart/form-data",
      });
    } catch (error) {
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
      console.log("bulkInsert", error);
      dispatch(setError(error.message));
      dispatch(endLoading());
    } finally {
      dispatch(endLoading());
    }
  };
};

export const searchContacts = (username, callback) => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      const res = await api.get(`contacts/getByName?username=${username}`);
      callback(res.data.result.items);
    } catch (error) {
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
      console.log("bulkInsert", error);
      dispatch(setError(error.message));
      callback([]);
      dispatch(endLoading());
    } finally {
      dispatch(endLoading());
    }
  };
};
